import { Bot } from "lucide-react";
import { NavigationItem } from "../../types";
import { BuilderContext } from "../context";

/**
 * Meridian / AI — the AI chat assistant, promoted out of the old "Other"
 * group into its own top-level section. Available to employees, CRM users,
 * and admins. (Meridian also lives in Slack — see MERIDIAN_SLACK_AVAILABILITY.)
 */
export function buildMeridianSection(ctx: BuilderContext): NavigationItem | null {
  const { isAdmin, isCRM, isEmployee, isClientUser } = ctx;

  if (!((isAdmin || isCRM || isEmployee) && !isClientUser)) return null;

  return {
    id: "meridian",
    name: "Meridian",
    href: "/chat",
    icon: Bot,
    visible: true,
    order: 7,
    children: [
      { id: "meridian-chat", name: "Chat", href: "/chat" },
      { id: "meridian-routines", name: "Routines", href: "/routines" },
    ],
  };
}
